import { render, staticRenderFns } from "./Renders.vue?vue&type=template&id=cec2851c&"
import script from "./Renders.vue?vue&type=script&lang=js&"
export * from "./Renders.vue?vue&type=script&lang=js&"
import style0 from "./Renders.vue?vue&type=style&index=0&id=cec2851c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports